// table-expand.vue
<style scoped>
    .expand-row{
        margin-bottom: 16px;
        word-wrap:break-word; word-break:break-all;
    }
</style>
<template>
    <div>
        <Row class="expand-row">
            <Col span="24">
                <span class="expand-key">{{title}}:</span>
            </Col>
            <Col span="24">
                <span class="expand-value">
                    <h4>{{row.message}}</h4>
                    <pre>{{ row.stacktrace}}</pre>
                </span>
            </Col>
        </Row>

    </div>
</template>
<script>
    export default {
        props: {
            title:String,
            row: Object
        },
    };
</script>